export function getPlayableVideoEl({ channels, currentChannelIndex, root = document } = {}) {
  const activeEl = root.querySelector('.channel-video.active');
  if (activeEl && activeEl.tagName === 'VIDEO') return activeEl;

  const currentChannel = Array.isArray(channels) ? channels[currentChannelIndex] : null;
  if (!currentChannel || !currentChannel.el) return null;
  if (currentChannel.el.tagName !== 'VIDEO') return null;
  return currentChannel.el;
}

